<template>
    <aside class="main-sidebar sidebar-dark-primary elevation-4" >
        <!-- Brand Logo -->
        <router-link :to="{name: 'admin'}" class="brand-link">
            <span class="brand-text font-weight-light">Arte-contemporary </span>
        </router-link>
        <!-- Sidebar -->
        <div class="sidebar os-host os-theme-dark os-host-resize-disabled os-host-scrollbar-horizontal-hidden os-host-scrollbar-vertical-hidden os-host-transition">
            <!-- Sidebar user panel (optional) -->
            <div class="user-panel mt-3 pb-3 mb-3 d-flex">
                <div class="image">
                </div>
                <div class="info text-light">
                    {{ $parent.user.name }}
                </div>
            </div>
            <!-- Sidebar Menu -->
            <nav class="mt-2">
                <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu" data-accordion="false">
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'artworksList'}" class="nav-link">
                            <i class="nav-icon fas fa-monument"></i>
                            <p>{{ $t('hi.artworks') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'categoriesList'}" class="nav-link">
                            <i class="nav-icon fas fa-list"></i>
                            <p>{{ $t('hi.categories') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'authorsList'}" class="nav-link">
                            <i class="nav-icon fas fa-person-booth"></i>
                            <p>{{ $t('hi.authors') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'usersList'}" class="nav-link">
                            <i class="nav-icon fas fa-users"></i>
                            <p>{{ $t('hi.users') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'pricesList'}" class="nav-link">
                            <i class="nav-icon fas fa-euro-sign"></i>
                            <p>{{ $t('hi.prices') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'productsList'}" class="nav-link">
                            <i class="nav-icon fas fa-beer"></i>
                            <p>{{ $t('hi.products') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'timeSlotsList'}" class="nav-link">
                            <i class="nav-icon fas fa-clock"></i>
                            <p>{{ $t('hi.time_slots') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'holidaysList'}" class="nav-link">
                            <i class="nav-icon fas fa-calendar-check"></i>
                            <p>{{ $t('hi.holidays') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'discountcodesList'}" class="nav-link">
                            <i class="nav-icon fas fa-percentage"></i>
                            <p>Códigos de Descuento </p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'taxesList'}" class="nav-link">
                            <i class="nav-icon fas fa-percentage"></i>
                            <p>{{ $t('hi.taxes') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'countriesList'}" class="nav-link">
                            <i class="nav-icon fas fa-map"></i>
                            <p>{{ $t('hi.countries') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'socialNetworksList'}" class="nav-link">
                            <i class="nav-icon fas fa-network-wired"></i>
                            <p>{{ $t('hi.socialNetworks') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'exhibitionsList'}" class="nav-link">
                            <i class="nav-icon fas fa-calendar"></i>
                            <p>{{ $t('hi.exhibitions') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1 || $parent.user.role_id === 3" class="nav-item">
                        <router-link :to="{name:'invoicesList'}" class="nav-link">
                            <i class="nav-icon fas fa-file"></i>
                            <p>{{ $t('hi.invoices') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'bookingsList'}" class="nav-link">
                            <i class="nav-icon fas fa-tasks"></i>
                            <p>{{ $t('hi.bookings') }}</p>
                        </router-link>
                    </li>
                    <li v-if="$parent.user.role_id === 1" class="nav-item">
                        <router-link :to="{name:'modalsList'}" class="nav-link">
                            <i class="nav-icon fas fa-window-maximize"></i>
                            <p>{{ $t('hi.modals') }}</p>
                        </router-link>
                    </li>
                    <li class="nav-item has-treeview">
                        <a href="/docs/3.0/components" class="nav-link ">
                            <i class="nav-icon fas fa-th"></i>
                            <p>
                                {{ $t('hi.personalizables') }}
                                <i class="right fas fa-angle-left"></i>
                            </p>
                        </a>
                        <ul class="nav nav-treeview" style="display: none;">
                            <li v-if="$parent.user.role_id === 1" class="nav-item">
                                <router-link :to="{name:'photographyCompetitionForm'}" class="nav-link">
                                    <i class="nav-icon fas fa-wrench"></i>
                                    <p>{{ ('Contenido Personalizado').substring(0, lengthStringsSidebar) }}{{ ('contenido_personalizado').length > lengthStringsSidebar ? '...' : '' }}

                                    </p>
                                </router-link>
                            </li>
                            <li v-if="$parent.user.role_id === 1" class="nav-item">
                                <router-link :to="{name:'reservationsTextForm'}" class="nav-link">
                                    <i class="nav-icon fas fa-text-height"></i>
                                    <p>{{ $t('hi.reservations_text').substring(0, lengthStringsSidebar) }}{{ $t('hi.reservations_text').length > lengthStringsSidebar ? '...' : '' }}

                                    </p>
                                </router-link>
                            </li>
                            <li v-if="$parent.user.role_id === 1" class="nav-item">
                                <router-link :to="{name:'inicioTextForm'}" class="nav-link">
                                    <i class="nav-icon fas fa-text-height"></i>
                                    <p>{{ $t('hi.inicio_text').substring(0, lengthStringsSidebar) }}{{ $t('hi.reservations_text').length > lengthStringsSidebar ? '...' : '' }}

                                    </p>
                                </router-link>
                            </li>
                            <li v-if="$parent.user.role_id === 1" class="nav-item">
                                <router-link :to="{name:'rapitaEbreForm'}" class="nav-link">
                                    <i class="nav-icon fas fa-street-view"></i>
                                    <p>{{ $t('hi.rapita_ebro_delta').substring(0, lengthStringsSidebar) }}{{ $t('hi.rapita_ebro_delta').length > lengthStringsSidebar ? '...' : '' }}
                                    </p>
                                </router-link>
                            </li>
                        </ul>
                    </li>
                </ul>
            </nav>
            <!-- /.sidebar-menu -->
        </div>
        <!-- /.sidebar -->
    </aside>

</template>

<script>
export default {
    name: "Sidebar.vue",
    data() {
        return {
            lengthStringsSidebar: 20
        };
    },
}
</script>

<style scoped>

</style>
